import styled from 'styled-components';
import t from 'prop-types';
import TableCell from '@material-ui/core/TableCell';

const AmpTableCell = styled(TableCell)`
  border: none;
  color: ${props => props.theme.colors.primary};
  font-family: inherit;
`;

AmpTableCell.propTypes = {
  style: t.object,
};

export default AmpTableCell;
